import React from 'react'

export default function FaceFeature({ scaleX, fill, outline }) {
  return (
    <g transform={`scale(${scaleX},1)`} fill="none">
      <path
        d="M63.39 3.64985C60.89 2.82985 53.24 1.88986 45.61 1.90986C37.83 1.91986 30.06 2.89985 27.78 3.64985C15.76 7.60985 -0.860045 43.4499 1.97996 58.8299C4.81996 74.2099 25.48 73.7399 25.48 73.7399C25.48 73.7399 19.69 66.3099 19.11 57.2299C18.33 45.0099 21.73 39.0599 21.73 39.0599C21.73 39.0599 57.09 30.6099 62.76 22.9899C62.76 22.9899 63.03 27.3299 69.14 36.2499C73.8 43.0499 75.54 55.5699 65.21 73.7299C65.21 73.7299 86.34 74.2099 89.18 58.8199C92.03 43.4599 75.42 7.61985 63.39 3.64985Z"
        fill={fill}
        stroke={outline}
        strokeWidth="2"
        strokeMiterlimit="10"
      />
      <path
        d="M27.8335 23.2655C27.5036 23.9191 27.177 24.5733 26.8521 25.2276L26.8521 25.2276L26.8497 25.2326C25.4568 28.1185 24.1416 31.0295 22.9759 34.0138C21.7575 36.9748 20.7624 40.0215 19.8604 43.0785L19.8603 43.0784L19.8583 43.0859L19.2728 45.1897C19.3923 44.4694 19.533 43.7532 19.6971 43.0425L19.6972 43.0425L19.6985 43.0363C20.383 39.8917 21.3149 36.7995 22.5231 33.8284C23.7367 30.8443 25.1069 27.9258 26.7127 25.1503L26.7141 25.148C27.0763 24.5141 27.4492 23.8862 27.8335 23.2655Z"
        fill={outline}
        stroke={outline}
      />
      <path
        d="M64.3499 5.04993C64.3499 5.04993 62.5999 11.6599 51.5499 19.4199C40.4999 27.1799 27.2599 29.49 22.8999 34.12"
        stroke={outline}
        strokeMiterlimit="10"
      />
      <path
        d="M67.4099 6.19995C67.4099 6.19995 66.0999 18.26 71.9199 28.49C74.5799 33.16 79.3499 41.03 81.2299 50.12C82.6699 57.07 82.1999 65.16 79.0499 70.6"
        stroke={outline}
        strokeMiterlimit="10"
      />
      <path
        d="M70.0199 9.01001C70.0199 9.01001 69.2899 15.9499 72.7799 24.0399C76.2699 32.1399 92.7099 53.27 86.1599 65.49"
        stroke={outline}
        strokeMiterlimit="10"
      />
      <path
        d="M73.2764 67.5497C72.3634 69.5126 71.2452 71.3935 69.8001 73.0529L69.4665 72.7193C70.9403 71.1978 72.1546 69.4054 73.1619 67.5039C73.5273 66.8141 73.859 66.107 74.1643 65.3882C73.8979 66.1194 73.6045 66.841 73.2764 67.5497Z"
        fill={outline}
        stroke={outline}
      />
      <path
        d="M62.0199 3.3999C62.0199 3.3999 60.9999 8.34998 49.5099 12.98C39.4499 17.03 26.0799 23.92 23.9099 31.64"
        stroke={outline}
        strokeMiterlimit="10"
      />
      <path
        d="M50.24 1.57996C50.24 1.57996 30.0199 6.19995 16.6399 29.3199C3.25995 52.4399 12.2799 72.7499 21.1499 73.4099"
        stroke={outline}
        strokeMiterlimit="10"
      />
      <path
        d="M5.93985 56.1695C5.91911 54.5025 5.98898 52.8387 6.14393 51.1846C6.03242 52.8428 6.00624 54.5039 6.07032 56.1594L6.07024 56.1594L6.07072 56.168C6.20217 58.5138 6.52609 60.8582 7.13648 63.1276C7.43462 64.2784 7.84398 65.3818 8.28879 66.4432L8.28873 66.4433L8.29175 66.4502C8.68241 67.3443 9.16748 68.2749 9.70694 69.0531L9.33762 69.3555C8.08166 67.4185 7.38607 65.3664 6.83514 63.2092C6.27576 60.9019 6.00921 58.5398 5.93985 56.1695Z"
        fill={outline}
        stroke={outline}
      />
    </g>
  )
}
